<script setup lang="ts">
import { ChevronDownIcon } from '@heroicons/vue/20/solid'
import type { MarketingFaqItem } from '~/types/marketing'

defineProps<{
  items: MarketingFaqItem[]
}>()
</script>

<template>
  <div class="mx-auto max-w-3xl divide-y divide-slate-200 border-y border-slate-200">
    <details v-for="item in items" :key="item.question" class="group py-1">
      <summary class="flex cursor-pointer list-none items-center justify-between gap-6 py-5 text-left text-base font-semibold text-slate-950 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-blue-500 focus-visible:ring-offset-2 sm:text-lg">
        <span>{{ item.question }}</span>
        <ChevronDownIcon class="h-5 w-5 shrink-0 text-slate-400 transition-transform group-open:rotate-180" aria-hidden="true" />
      </summary>
      <p class="max-w-2xl pb-6 pr-10 text-[15px] leading-7 text-slate-600 sm:text-base">
        {{ item.answer }}
      </p>
    </details>
  </div>
</template>
